export const ESTADOS_PAGO = [
  { value: "pendiente", label: "Pendiente" },
  { value: "parcial", label: "Pago parcial" },
  { value: "pagado", label: "Pagado" },
];

export const estadoPagoLabel = (value = "") => {
  const found = ESTADOS_PAGO.find((item) => item.value === value);
  return found ? found.label : (value || "Desconocido");
};
